import store from "..";

let User = {
    namespaced:true,
    state:{
        token:'',
        loginUser:{},
        user:{}
    },
    mutations: {
		// 点击按钮，mutation处理，在返回给页面，做出相应操作
		// toggleMenu(state) { // 5、改
		// 	state.isCollapse = !state.isCollapse
		// },
	},
    actions:{
        // async getUser({dispatch,commit}){

        // }
    },
	// 计算属性
	
}

export default User;